import AddressLine from './AddressLine'

export default AddressLine
